module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Previous configuration already exists","text":"This will override the previously issued configration file. Do you wish to continue?","ok":"Yes","cancel":"No"},"da":{"title":"Tidligere konfigurationsfil findes","text":"Dette over overskrive den tidligere konfigurationsfil. Ønsker du at fortsætte?","ok":"Ja","cancel":"Nej"}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./~/@kazupon/vue-i18n-loader/lib!./~/vue-loader/lib/selector.js?type=customBlocks&index=0!./WebApp/components/modals/PreviousConfigurationExistsModal.vue
// module id = 595
// module chunks = 0